import template from './employee_view_management_component.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewManagementComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee_id = ko.observable();
		this.employee = ko.observable();
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.selected_subordinate = ko.observable();
		this.selected_manager = ko.observable();
		this.selected_backup_manager = ko.observable(); 
		this.only_when_on_leave = ko.observable(false);
		this.my_managers = ko.observableArray();
		this.my_backup_managers = ko.observableArray();
		this.my_subordinates = ko.observableArray();
		this.all_managers_to_add = ko.observableArray();
		this.all_backup_managers_to_add = ko.observableArray();
		this.all_subordinates_to_add = ko.observableArray();
		this.add_manager_search_string = ko.observable('');
		this.add_backup_manager_search_string = ko.observable('');
		this.add_sub_search_string = ko.observable('');
		this.my_departments = ko.observableArray();
		
		//Permissions
		this.can_demote = ko.observable(false);
		this.can_promote = ko.observable(false);

		this.add_manager_search_string.subscribe((value) => {
			this.checkSearchAccess();
		});

		this.add_backup_manager_search_string.subscribe((value) => {
			this.checkSearchAccess();
		});

		this.add_sub_search_string.subscribe((value) => {
			this.checkSearchAccess();
		})

		if (bindings.employee && ko.isObservable(bindings.employee))
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(this.employee().employee_id);
					this.loadPage();
				}
			});

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });
	}

	async updateData()
	{
		if (this.bindings.onReload && this.bindings.onReload instanceof Function)
			this.bindings.onReload.apply(null, []);
		this.loadPage();
	};

	async loadPage()
	{
		try {
			await this.checkSearchAccess();
			await this.load_manager_data();
			await this.load_subordinate_data();
			await this.load_user_roles();
			await this.load_department_data();
			await this.load_backup_manager_data();
		} catch (err) {
			console.error('While loading employee_view_management_component', err);
		}
	};

	async load_user_roles()
	{
		// manager promotion display
		let options = {
			table: 'user_role',
			schema: 'grape',
			limit: 1000000,
			sortfield: 'role_name',
			sortorder: 'asc',
			filter: [{ value: this.employee().grape_user_id, op: '=', field: 'user_id' }]
		}
	
		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res)
		{
			if (Permissions.isLoggedInUser_Admin())
			{
				let roles = res.records.map(r => r.role_name);
				if (roles.includes('manager'))
				{
					if (roles.includes('general_manager'))
					{
						this.can_demote(true);
						this.can_promote(false);
					}
					else
					{
						this.can_promote(true);
						this.can_demote(false);
					}
				}
			}
		}
	};

	async load_manager_data ()
	{
		// MY MANAGER TABLE
		let my_manager_options = {
			table: 'v_employees_manager',
			schema: 'savanna',
			offset: 0,
			limit: 100,
			sortfield: 'surname',
			sortorder: 'ASC',
			filter: [
				{ value: this.employee_id(), op: '=', field: 'subordinate_employee_id' }, { value: true, op: '=', field: 'active' }
			]
		};

		let result = await Grape.fetches.getJSON('/api/record', my_manager_options);

		if (result.records != null)
		{
			// hide options that only admin can see
			let permission = await Permissions.checkAccessRights('EmployeeAdministation');

			let managers = result.records.map(item => ({
				...item,
				permission: permission,
				img_src: `/download/employee/${String(item.employee_id_photo)}/photo`
			}));
			this.my_managers(managers);
		}
	};

	async load_backup_manager_data()
	{
		// MY BACKUP MANAGER TABLE
		let my_manager_options = {
			table: 'v_backup_managers',
			schema: 'savanna',
			offset: 0,
			limit: 100,
			sortfield: 'surname',
			sortorder: 'ASC',
			filter: [
				{ value: this.employee_id(), op: '=', field: 'manager_id' }, { value: true, op: '=', field: 'active' }
			]
		};

		let result = await Grape.fetches.getJSON('/api/record', my_manager_options);

		if (result.records != null)
		{
			// hide options that only admin can see
			let permission = await Permissions.checkAccessRights('EmployeeAdministation');

			let managers = result.records.map(item => ({
				...item,
				permission: permission,
				img_src: `/download/employee/${String(item.employee_id_photo)}/photo`
			}));
			this.my_backup_managers(managers);
		}
	};

	async load_subordinate_data()
	{
		// MANAGER TAB TABLE
		let options = {
			table: 'v_manager_employee',
			schema: 'savanna',
			offset: 0,
			limit: 1000,
			sortfield: 'surname',
			sortorder: 'ASC',
			filter: [
				{ value: this.employee_id(), op: '=', field: 'manager_employee_id' },
				{ value: true, op: '=', field: 'active'}
			]
		};

		let result = await Grape.fetches.getJSON('/api/record', options);

		if (result.records != null)
		{
			// hide options that only admin can see
			let permission = await Permissions.checkAccessRights('EmployeeAdministation');

			let subordinates = result.records.map(item => ({
				...item,
				permission: permission,
				img_src: `/download/employee/${String(item.employee_id_photo)}/photo`
			}));
			this.my_subordinates(subordinates);
		}
	};

	async load_department_data()
	{
		// DEPARTMENT TAB TABLE
		let options = {
			table: 'v_manager_department',
			schema: 'savanna',
			offset: 0,
			limit: 100,
			sortfield: 'surname',
			sortorder: 'ASC',
			filter: [{ value: this.employee_id(), op: '=', field: 'employee_id' },
				{ value: true, op: '=', field: 'active' }]
		};

		let result = await Grape.fetches.getJSON('/api/record', options);

		if (result.records != null)
		{
			// hide options that only admin can see
			let permission = await Permissions.checkAccessRights('EmployeeAdministation');

			let dep = result.records.map(item => ({
				...item,
				permission: permission
			}));

			this.my_departments(dep);
		}
	};

	async checkSearchAccess()
	{
		// this is for the search bar
		let table = 'v_restricted_access_list_assistant_managers';
		let schema = 'savanna';
		Permissions.checkAccessRights('ViewEmployeeListFull').then((v) => {
			// the person has access
			if (v == true)
			{
				// can access complete employee database
				table = 'employee';
				schema = 'public';
				this.loadSearchData(table, schema);
			} else
			{
				// person doesnt have full rights so lets check if they have partial rights
				Permissions.checkAccessRights('ViewEmployeeListPartial').then((v) => {
					if (v == true)
					{
						// can access restricted list
						table = 'v_restricted_access_list';
						schema = 'savanna';
						this.loadSearchData(table, schema);
					}
					else
					{
						// user has no rights (employee)
						this.loadSearchData(table, schema);
					}
				});
			}
		});
	};

	async add_all_department_subordinates(v, e)
	{
		let data = ko.mapping.toJS(v);
		let option = {
			employee_id: this.employee_id(),
			company: data.company,
			company_id: data.company_id,
			department: data.department,
			department_id: data.department_id
		}

		let response = await Grape.alerts.confirm({type: 'warning', message: tr('You are about to add all people from this department as a subordinate to this person. Continue?')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/manager_department/add_all_as_subordinate', option);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully added subordinates.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};

	select_backup_manager(data)
	{
		this.selected_backup_manager(data);
		this.add_backup_manager_search_string(data.firstname + ' ' + data.surname);
	}

	select_manager(data)
	{
		this.selected_manager(data);
		this.add_manager_search_string(data.firstname + ' ' + data.surname);
	}

	select_subordinate(data)
	{
		this.selected_subordinate(data);
		this.add_sub_search_string(data.firstname + ' ' + data.surname);
	}

	async remove_backup_manager(data)
	{
		let option = {
			backup_manager_id: data.employee_id,
			manager_id: this.employee_id()
		};

		let res = await Grape.fetches.postJSON('/manager/remove_backup_manager', option);
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully removed manager.'), title: tr('Success') });
			this.loadPage();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	};

	async remove_subordinate(data)
	{
		let option = {
			subordinate_employee_id: data.employee_id,
			employee_id: this.employee_id()
		};

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this subordinate?')});
		
		if (response)
		{
			let res = await Grape.fetches.postJSON('/manager/remove_subordinate', option);
			
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully removed employee.'), title: tr('Success')});
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	async remove_manager(data)
	{
		let options = {
			manager_employee_id: data.manager_employee_id,
			employee_id: data.subordinate_employee_id
		};

		let res = await Grape.fetches.postJSON('/manager/remove_manager', options);
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully removed manager.'), title: tr('Success') });
			this.loadPage();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	};

	async promote_manager()
	{
		let data = {
			employee_id: this.employee_id(),
			role_from: 'manager',
			role_to: 'general_manager',
			type: 'PROMOTE'
		};

		let res = await Grape.fetches.postJSON('/manager/promote_demote_user', data);
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: res.message, title: tr('Success') });
			this.loadPage();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	}

	async demote_general_manager()
	{
		let data = {
			employee_id: this.employee_id(),
			role_from: 'general_manager',
			role_to: '', // nothing here
			type: 'DEMOTE'
		};

		let res = await Grape.fetches.postJSON('/manager/promote_demote_user', data);
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: res.message, title: tr('Success') });
			this.loadPage();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	}

	async add_subordinate()
	{
		if (this.selected_subordinate())
		{
			try {
				let options = {
					subordinate_employee_id: this.selected_subordinate().employee_id,
					employee_id: this.employee_id()
				};

				let res = await Grape.fetches.postJSON('/manager/add_subordinate', options);

				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully added employee.'), title: tr('Success') });
					this.loadPage();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			} catch (error) {
				Grape.alerts.alert({ type: 'error', message: tr('Invalid subordinate name'), title: tr('Error') });
			}
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Invalid subordinate name'), title: tr('Error') });

		this.selected_subordinate(null);
		this.add_sub_search_string('');
	}

	async add_manager()
	{
		if (this.selected_manager())
		{
			let options = {
				manager_employee_id: this.selected_manager().employee_id,
				employee_id: this.employee_id()
			};

			let res = await Grape.fetches.postJSON('/manager/add_manager', options);
			
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully added a manager.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Invalid manager name'), title: tr('Error') });

		this.selected_manager(null);
		this.add_manager_search_string('');
	}

	async add_backup_manager()
	{
		if (this.selected_backup_manager())
		{
			let option = {
				manager_id: this.employee_id(),
				backup_manager_id: this.selected_backup_manager().employee_id,
				only_when_on_leave: this.only_when_on_leave()
			};
			
			let res = await Grape.fetches.postJSON('/manager/add_backup_manager', option);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully added a backup manager.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Invalid manager name'), title: tr('Error') });

		this.selected_backup_manager(null);
		this.add_backup_manager_search_string('');
	}

	async add_manager_department()
	{
		await Grape.dialog.open('EmployeeAddManagerDepartment', { employee_id: this.employee_id() });
		await this.loadPage();
	}

	async delete_manager_department(data)
	{
		let dep = ko.mapping.toJS(data);
		dep.employee_id = this.employee_id();

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this department entry ?')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/manager_department/delete', dep);

			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted department.'), title: tr('Success') });
				this.loadPage();
				//edit_row.hide();
			}
			else if (res.status == 'NOT_ALLOWED')
				Grape.alerts.alert({ type: 'warning', message: tr('A person cannot have less than one department assigned.'), title: tr('Denied') });
			else if (res.status == 'NOT_ALLOWED_ACTIVE_DEPARTMENT')
				Grape.alerts.alert({ type: 'warning', message: tr('You cannot delete this department entry because it is currently being used.'), title: tr('Denied') });
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};

	show_managers_help()
	{
		Grape.dialog.open('ManagersHelp', { employee_id: this.logged_in_employee_id });
	}

	show_backup_managers_help()
	{
		Grape.dialog.open('BackupManagersHelp', { employee_id: this.logged_in_employee_id });
	}

	show_promote_demote_help()
	{
		Grape.dialog.open('PromoteDemoteHelp', { employee_id: this.logged_in_employee_id });
	}

	show_managed_departments_help()
	{
		Grape.dialog.open('ManagedDepartmentsHelp', { employee_id: this.logged_in_employee_id });
	}

	show_managed_employees_help()
	{
		Grape.dialog.open('ManagedEmployeesHelp', { employee_id: this.logged_in_employee_id });
	}

	async loadSearchData(table, schema) {
		// --- Search and get data for adding manager ---
		if (this.add_manager_search_string() && this.add_manager_search_string().trim() !== '') {
			let option = {
				table: table,
				       schema: schema,
				       limit: 50,
				       filter_join: 'OR',
				       filter: [
				       {
						field: 'firstname',
						       operand: 'ILIKE',
						       value: `%${this.add_manager_search_string()}%`
						       },
						       {
						field: 'surname',
						       operand: 'ILIKE',
						       value: `%${this.add_manager_search_string()}%`
						       }
       				]
			};

			let result = await Grape.fetches.getJSON('/api/record', option);
			if (result.status !== 'ERROR' && result.records != null) {
				this.all_managers_to_add(result.records);
			} else {
				this.all_managers_to_add([]);
			}
		} else {
			this.all_managers_to_add([]);
		}

		// --- Search and get data for adding backup manager ---
		if (this.add_backup_manager_search_string() && this.add_backup_manager_search_string().trim() !== '') {
			let option = {
				table: table,
				       schema: schema,
				       limit: 50,
				       filter_join: 'OR',
				       filter: [
						       {
						field: 'firstname',
						       operand: 'ILIKE',
						       value: `%${this.add_backup_manager_search_string()}%`
						       },
						       {
						field: 'surname',
						       operand: 'ILIKE',
						       value: `%${this.add_backup_manager_search_string()}%`
						       }
				       ]
			};

			let result = await Grape.fetches.getJSON('/api/record', option);
			if (result.status !== 'ERROR' && result.records != null) {
				this.all_backup_managers_to_add(result.records);
			} else {
				this.all_backup_managers_to_add([]);
			}
		} else {
			this.all_backup_managers_to_add([]);
		}

		if (this.add_sub_search_string() && this.add_sub_search_string().trim() !== '') {
			let option = {
				table: table,
				       schema: schema,
				       limit: 50,
				       filter_join: 'OR',
				       filter: [
					       {
					field: 'firstname',
					       operand: 'ILIKE',
					       value: `%${this.add_sub_search_string()}%`
					       },
					       {
					field: 'surname',
					       operand: 'ILIKE',
					       value: `%${this.add_sub_search_string()}%`
					       }
			       ]
			};

			let result = await Grape.fetches.getJSON('/api/record', option);
			if (result.status !== 'ERROR' && result.records != null) {
				this.all_subordinates_to_add(result.records);
			} else {
				this.all_subordinates_to_add([]);
			}
		} else {
			this.all_subordinates_to_add([]);
		}
	}



}

export default {
	name: 'employee_view_management_component',
	viewModel: EmployeeViewManagementComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_management_component'
};
